<template>
  <div class="patient-fif">
    <v-overlay :value="loading" z-index="4">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
    <v-container class="patient-fif__header">
      <v-row class="align-start justify-space-between">
        <v-col>
          <h5 class="patient-fif__header-title accent--text" v-if="tenantTexts.participantSmartSurvey.pageTitle.bold">{{ tenantTexts.participantSmartSurvey.pageTitle.bold }}</h5>
          <p class="patient-fif__header-subtitle accent--text" v-if="tenantTexts.participantSmartSurvey.pageTitle.normal">{{ tenantTexts.participantSmartSurvey.pageTitle.normal }}</p>
        </v-col>
        <v-col class="text-right">
          <h5
            class="patient-fif__header-date bhGray2--text"
            v-if="form.creationDate"
          >
            {{ form.creationDate | moment("MMMM Do, YYYY") }}
          </h5>
        </v-col>
      </v-row>
    </v-container>
    <v-container
      class="patient-fif__patient-data"
      v-if="formNotFilled && !loading && !form.rawValue"
    >
      <v-row>
        <v-col>
          <h4>Survey is not filled yet.</h4>
        </v-col>
      </v-row>
    </v-container>
    <v-container
      class="patient-fif__patient-data"
      v-if="!formNotFilled && !loading && form.rawValue"
    >
      <v-row>
        <v-col>
          <p class="label">
            Date of Birth
          </p>
          <p
            class="patient-fif__patient-data-value"
            v-if="form.rawValue.dateOfBirth"
          >
            {{ form.rawValue.dateOfBirth | moment("MMMM Do, YYYY") }}
          </p>
          <p class="patient-fif__patient-data-value" v-else>&nbsp;</p>
        </v-col>
        <v-col>
          <p class="label">
            Height
          </p>
          <p class="patient-fif__patient-data-value" v-if="isFullSurvey">
            {{ form.rawValue.yourHeightFeet || "-" }}'{{
              form.rawValue.yourHeightInches || "-"
            }}"
          </p>
          <p class="patient-fif__patient-data-value" v-else>
            -'-"
          </p>
        </v-col>
        <v-col>
          <p class="label">
            Current Weight
          </p>
          <p class="patient-fif__patient-data-value" v-if="isFullSurvey">
            {{ form.rawValue.currentWeight || "-" }} lbs
          </p>
          <p class="patient-fif__patient-data-value" v-else>
            - lbs
          </p>
        </v-col>
        <v-col>
          <p class="label">
            Target weight
          </p>
          <p class="patient-fif__patient-data-value" v-if="isFullSurvey">
            {{ form.rawValue.targetWeight || "-" }} lbs
          </p>
          <p class="patient-fif__patient-data-value" v-else>
            - lbs
          </p>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
          <p class="label label--underlined">
            Questions
          </p>
        </v-col>
        <v-col cols="12" class="patient-fif__question pt-0">
          <p>
            <strong
              >To begin, could you share the top things you are seeking to
              accomplish in this program?</strong
            >
          </p>
          <p>{{ form.rawValue.goals || "-" }}</p>
        </v-col>
        <v-col cols="12" class="patient-fif__question">
          <p>
            <strong
              >What are the things most working for you today to reach your
              goals?</strong
            >
          </p>
          <p>{{ form.rawValue.goalsSupporters || "-" }}</p>
        </v-col>
        <v-col cols="12" class="patient-fif__question">
          <p>
            <strong
              >What are the things most working against those goals?</strong
            >
          </p>
          <p>{{ form.rawValue.goalsSuppressors || "-" }}</p>
        </v-col>
        <v-col cols="12" class="patient-fif__question">
          <p>
            <strong
              >What are the best things you could receive from this program to
              support you?</strong
            >
          </p>
          <p>{{ form.rawValue.expectations || "-" }}</p>
        </v-col>
        <v-col cols="12" class="patient-fif__question">
          <p>
            <strong
              >Is weight gain or loss something you are seeking in this
              program?</strong
            >
          </p>
          <p>{{ form.rawValue.weightChangeFlag || "-" }}</p>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" class="patient-fif__question">
          <p>
            <strong>Could you share an overview of your weight history?</strong>
          </p>
          <p v-if="isFullSurvey">
            {{ form.rawValue.weightHistory || "-" }}
          </p>
          <p v-else>
            -
          </p>
        </v-col>
        <v-col cols="12" class="patient-fif__question">
          <p>
            <strong>Who is the main grocery shopper for the household?</strong>
          </p>
          <p v-if="isFullSurvey">
            {{ form.rawValue.mainGroceryHouseholdShopper || "-" }}
          </p>
          <p v-else>
            -
          </p>
        </v-col>
        <v-col cols="12" class="patient-fif__question">
          <p>
            <strong
              >Who does the main meal preparation for the household?</strong
            >
          </p>
          <p v-if="isFullSurvey">
            {{ form.rawValue.mealPreparationForHousehold || "-" }}
          </p>
          <p v-else>
            -
          </p>
        </v-col>
        <v-col cols="12" class="patient-fif__question">
          <p>
            <strong
              >What family members/others are living and eating with you
              regularly and could you briefly characterize their eating styles
              relative to yours?</strong
            >
          </p>
          <p v-if="isFullSurvey">
            {{ form.rawValue.familyEatingDescription || "-" }}
          </p>
          <p v-else>
            -
          </p>
        </v-col>
        <v-col cols="12" class="patient-fif__question">
          <p>
            <strong
              >Could you describe the physical activity/activity you undertake
              in a typical week?</strong
            >
          </p>
          <p v-if="isFullSurvey">
            {{ form.rawValue.physicalActivity || "-" }}
          </p>
          <p v-else>
            -
          </p>
        </v-col>
        <v-col cols="12" class="patient-fif__question">
          <p>
            <strong
              >Approximately how often do you eat out or get takeout each week
              from restaurants?</strong
            >
          </p>
          <p v-if="isFullSurvey">
            {{ form.rawValue.oftenEatOut || "-" }}
          </p>
          <p v-else>
            -
          </p>
        </v-col>
        <v-col cols="12" class="patient-fif__question">
          <p>
            <strong
              >What are the types of foods you are most regularly eating from
              those restaurants?</strong
            >
          </p>
          <ul
            v-if="
              isFullSurvey &&
                form.rawValue['restaurantFoods'] &&
                form.rawValue['restaurantFoods'].length
            "
          >
            <li v-if="form.rawValue['restaurantFoods'][0]">
              {{ form.rawValue["restaurantFoods"][0] }}
            </li>
            <li v-if="form.rawValue['restaurantFoods'][1]">
              {{ form.rawValue["restaurantFoods"][1] }}
            </li>
            <li v-if="form.rawValue['restaurantFoods'][2]">
              {{ form.rawValue["restaurantFoods"][2] }}
            </li>
            <li v-if="form.rawValue['restaurantFoods'][3]">
              {{ form.rawValue["restaurantFoods"][3] }}
            </li>
            <li v-if="form.rawValue['restaurantFoods'][4]">
              {{ form.rawValue["restaurantFoods"][4] }}
            </li>
          </ul>
          <p v-else>-</p>
        </v-col>
        <v-col cols="12" class="patient-fif__question">
          <p>
            <strong>Do you have any injuries that limit you physically?</strong>
          </p>
          <ul
            v-if="
              isFullSurvey &&
                form.rawValue['injuries'] &&
                form.rawValue['injuries'].length
            "
          >
            <li v-if="form.rawValue['injuries'][0]">
              {{ form.rawValue["injuries"][0] }}
            </li>
            <li v-if="form.rawValue['injuries'][1]">
              {{ form.rawValue["injuries"][1] }}
            </li>
            <li v-if="form.rawValue['injuries'][2]">
              {{ form.rawValue["injuries"][2] }}
            </li>
            <li v-if="form.rawValue['injuries'][3]">
              {{ form.rawValue["injuries"][3] }}
            </li>
            <li v-if="form.rawValue['injuries'][4]">
              {{ form.rawValue["injuries"][4] }}
            </li>
          </ul>
          <p v-else>-</p>
        </v-col>
        <v-col cols="12" class="patient-fif__question">
          <p>
            <strong
              >What, if any, medical conditions are you currently
              experiencing?</strong
            >
          </p>
          <ul
            v-if="
              isFullSurvey &&
                form.rawValue['medicalConditions'] &&
                form.rawValue['medicalConditions'].length
            "
          >
            <li
              v-for="(medical, key) in form.rawValue['medicalConditions']"
              :key="`medical-conditions-${key}`"
            >
              {{ medical || "-" }}
            </li>
          </ul>
          <p v-else>-</p>
        </v-col>
        <v-col cols="12" class="patient-fif__question">
          <p>
            <strong
              >Please list medications you are presently taking and for what
              condition?</strong
            >
          </p>
          <ul
            v-if="
              isFullSurvey &&
                form.rawValue['drugs'] &&
                form.rawValue['drugs'].length
            "
          >
            <template v-for="(drug, key) in form.rawValue['drugs']">
              <li
                :key="`drug-${key}`"
                v-if="
                  drug.name &&
                    drug.name.length > 0 &&
                    drug.howOften &&
                    drug.howOften.length > 0
                "
              >
                {{ drug.name || "-" }}, dose:
                {{
                  drug.howOften != "Never or rarely"
                    ? drug.numberOfPortions || "-"
                    : ""
                }}
                {{ drug.howOften }}
              </li>
            </template>
          </ul>
          <p v-else>-</p>
        </v-col>
        <v-col cols="12" class="patient-fif__question">
          <p>
            <strong
              >We have identified 12 Food Categories. Please indicate how much
              of a challenge you find each of these in attaining your
              goals.</strong
            >
          </p>
          <ul class="patient-fif__question-challenges">
            <li class="mb-2">
              <strong>{{
                !isFullSurvey
                  ? "Not selected"
                  : form.rawValue.takeoutFoods.challenge || "Not selected"
              }}</strong>
              - Takeout Foods (foods purchased from restaurants)
            </li>
            <li class="mb-2">
              <strong>{{
                !isFullSurvey
                  ? "Not selected"
                  : form.rawValue.balancedPlateComposition.challenge ||
                    "Not selected"
              }}</strong>
              - Balanced plate composition (proper balancing of proteins, carbs,
              and fats)
            </li>
            <li class="mb-2">
              <strong>{{
                !isFullSurvey
                  ? "Not selected"
                  : form.rawValue.beverages.challenge || "Not selected"
              }}</strong>
              - Beverages (coffee, tea, alcohol, juices, soft drinks, flavored
              waters, etc.)
            </li>
            <li class="mb-2">
              <strong>{{
                !isFullSurvey
                  ? "Not selected"
                  : form.rawValue.dairy.challenge || "Not selected"
              }}</strong>
              - Dairy (milk, cheese, yogurt, creams, etc.)
            </li>
            <li class="mb-2">
              <strong>{{
                !isFullSurvey
                  ? "Not selected"
                  : form.rawValue.snacks.challenge || "Not selected"
              }}</strong>
              - Snacks (crisps, crackers, nuts, etc.)
            </li>
            <li class="mb-2">
              <strong>{{
                !isFullSurvey
                  ? "Not selected"
                  : form.rawValue.protein.challenge || "Not selected"
              }}</strong>
              - Protein (animal and plant sources)
            </li>
            <li class="mb-2">
              <strong>{{
                !isFullSurvey
                  ? "Not selected"
                  : form.rawValue.sweeteners.challenge || "Not selected"
              }}</strong>
              - Sweeteners (sugar, honey, artificial sweeteners, syrups, jelly,
              etc.)
            </li>
            <li class="mb-2">
              <strong>{{
                !isFullSurvey
                  ? "Not selected"
                  : form.rawValue.simpleCarbs.challenge || "Not selected"
              }}</strong>
              - Simple Carbs (cereals, cakes, breads, cookies, etc.)
            </li>
            <li class="mb-2">
              <strong>{{
                !isFullSurvey
                  ? "Not selected"
                  : form.rawValue.saucesSpreads.challenge || "Not selected"
              }}</strong>
              - Sauces & Spreads (dips, dressings, sauces, condiments,
              guacamole, etc.)
            </li>
            <li class="mb-2">
              <strong>{{
                !isFullSurvey
                  ? "Not selected"
                  : form.rawValue.preparedFoods.challenge || "Not selected"
              }}</strong>
              - Prepared Foods (frozen foods, premade meals, etc.)
            </li>
            <li class="mb-2">
              <strong>{{
                !isFullSurvey
                  ? "Not selected"
                  : form.rawValue.restaurantDining.challenge || "Not selected"
              }}</strong>
              - Restaurant Dining (eating inside restaurants)
            </li>
            <li class="mb-2">
              <strong>{{
                !isFullSurvey
                  ? "Not selected"
                  : form.rawValue.holidaysParties.challenge || "Not selected"
              }}</strong>
              - Holidays & Parties (eating at special events and occasions)
            </li>
          </ul>
        </v-col>
        <v-col cols="12" class="patient-fif__question">
          <p>
            <strong
              >We would love to get a snapshot of you and your family if you are
              inclined.<br />Please upload up to 2 pictures if you would be open
              to sharing.</strong
            >
          </p>
          <div class="patient-fif__photos mb-4" v-if="isFullSurvey">
            <div
              class="patient-fif__photo-wrap"
              v-for="(image, imageId) in formPictures"
              :key="image"
            >
              <p class="mb-2" v-if="picturesFull[image] && image == 'You'">
                You
              </p>
              <p
                class="mb-2"
                v-else-if="picturesFull[image] && image == 'Family'"
              >
                Family
              </p>
              <p class="mb-2" v-else>&nbsp;</p>
              <v-img
                v-if="picturesFull[image]"
                min-height="128"
                min-width="160"
                :src="
                  picturesFull[image] && picturesFull[image].thumbnailUrl
                    ? picturesFull[image].thumbnailUrl
                    : picturesFull[image].mediaUrl
                "
                :lazy-src="
                  picturesFull[image] && picturesFull[image].thumbnailUrl
                    ? picturesFull[image].thumbnailUrl
                    : picturesFull[image].mediaUrl
                "
                @click="openImage(imageId)"
                class="patient-fif__photo rounded-sm"
                width="160"
                height="128"
              >
                <template v-slot:placeholder>
                  <v-row
                    class="fill-height ma-0"
                    align="center"
                    justify="center"
                  >
                    <v-progress-circular
                      size="32"
                      indeterminate
                      color="bhBlue2"
                    ></v-progress-circular>
                  </v-row>
                </template>
              </v-img>
            </div>
          </div>
        </v-col>
      </v-row>
    </v-container>
    <light-box ref="fifPhotos" :images="lightBoxPictures" />
    <v-snackbar v-model="notificationSnackbar">
      {{ notificationSnackbarText }}
      <template v-slot:action="{ attrs }">
        <v-btn
          color="blue"
          text
          v-bind="attrs"
          @click="notificationSnackbar = false"
        >
          Close
        </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
// import axios from 'axios';
import { debounce } from "@/helpers/debounce";
import LightBox from "@/components/LightBox.vue";
import TenantTextsMixin from "@/mixins/tenantTexts";

// @ is an alias to /src
export default {
  name: "PatientSmartSurvey",
  components: {
    LightBox,
  },
  mixins: [
    TenantTextsMixin
  ],
  data: () => ({
    loading: false,
    notificationSnackbar: false,
    notificationSnackbarText: "",
    activeTab: 0,
    formNotFilled: true,
    form: {},
    picturesFull: {},
    lightBoxPictures: [],
  }),
  computed: {
    ...mapState('patientsStates', ['currentPatient']),
    formPictures() {
      const that = this;
      let pictures = this.form.mediaKinds || [];
      pictures = pictures.slice().reverse();

      return pictures;
    },
    isFullSurvey() {
      return this.form.rawValue.weightChangeFlag === true;
    },
  },
  methods: {
    ...mapActions("patientsStates", [
      'getPatient',
      "getParticipantSmartSurvey",
      "getParticipantSmartSurveyImage",
    ]),
    getFileName(nameWithExt = "") {
      let name = nameWithExt.split(".");

      if (Array.isArray(name) && name.length > 0) {
        name = name[0];
      }

      name = name.trim().toLowerCase();

      return name;
    },
    openImage(index) {
      this.$refs.fifPhotos.openLightBoxImage(index);
    },
    updateLightBoxPictures() {
      let pictures = this.formPictures;
      pictures = pictures.map((el) =>
        this.picturesFull?.[el]?.mediaUrl
          ? this.picturesFull?.[el]?.mediaUrl
          : this.picturesFull?.[el]?.thumbnailUrl
      );

      this.lightBoxPictures = [...pictures];
    },
    getSmartSuvey() {
      this.getParticipantSmartSurvey({ participantId: this.$route.params.id })
        .then((response) => {
          if (response.code == 404) {
            return;
          }

          this.formNotFilled = false;
          this.form = { ...response };

          const {
            dateOfBirthDay,
            dateOfBirthMonth,
            dateOfBirthYear,
          } = this.form.rawValue;

          if (dateOfBirthDay && dateOfBirthMonth && dateOfBirthYear) {
            this.form.rawValue.dateOfBirth = new Date(
              dateOfBirthYear,
              parseInt(dateOfBirthMonth, 10) - 1,
              dateOfBirthDay
            );
          }

          this.getSmartSuveyPictures();
        })
        .catch((error) => {
          if (error && error.code == 400) {
            this.notificationSnackbar = true;
            this.notificationSnackbarText = "Cannot get Smart Survey data.";
          }

          if (error?.code != 400) {
            this.formNotFilled = false;
          }

          this.notificationSnackbar = true;
          this.notificationSnackbarText =
            "Unexpeced error while getting smart survey.";
        });
    },
    getSmartSuveyPictures() {
      (this.form?.mediaKinds || []).forEach((el) => {
        this.getParticipantSmartSurveyImage({
          mediaKind: el,
          participantId: this.$route.params.id,
        })
          .then((response) => {
            this.picturesFull[el] = response?.media;
            this.picturesFull = { ...this.picturesFull };
            this.updateLightBoxPictures();

            if (response?.media?.isProcessing) {
              debounce(() => this.getSmartSuveyPictures(), 15000);
            }
          })
          .catch((error) => {
            console.error({
              name: "Cannot get participant smart survey image: " + el,
              error,
            });
          });
      });
    },
  },
  watch: {
    currentPatient(val) {
      if (val && String(this.$route.params?.id) === String(val?.id)) {
        this.getSmartSuvey();
      }
    },
    $route (to, from) {
      // get new current patient data when patient id changed
      if (to.params?.id !== undefined && from.params?.id !== to.params?.id) {
        this.getPatient(to.params.id)
      }
    }
  },
  mounted() {
    this.getSmartSuvey();
  },
};
</script>

<style lang="scss">
@import "@/styles/variables.scss";

.patient-fif {
  padding: 32px;

  &__patient-data {
    &-value {
      font-weight: 700;
      font-size: 1.1428rem;
      line-height: 1.5em;
      color: $bh-gray--1;
      word-break: break-word;
    }
  }

  &__header {
    &-title {
      margin-bottom: 0;
    }

    &-subtitle {
      font-size: 1.0715rem;
      line-height: 1.333333em;
    }
  }

  &__photos {
    margin-left: -8px;
    margin-right: -8px;
    display: inline-block;
    width: calc(100% + 16px);
  }

  &__photo {
    cursor: pointer;

    &-wrap {
      float: left;
      margin: 0 8px;
    }
  }

  &__tabs {
    height: auto;

    &-header {
      padding-left: 0;
      padding-right: 12px;
      flex-direction: column;
      justify-content: flex-start;
      align-items: flex-start;
      text-align: left;

      & + & {
        padding-left: 12px;
      }

      // &:last-of-type {
      //   padding-right: 0;
      // }

      &-step {
        padding-top: 6px;
        font-size: 0.5715rem;
        line-height: 1;
        display: block;
      }

      &-title {
        font-size: 0.715rem;
        line-height: 1.6em;
        font-weight: 700;
        padding-bottom: 6px;
        display: inline-block;
      }
    }

    .v-tabs-slider-wrapper {
      border-radius: 2px;
    }

    .v-slide-group {
      margin-bottom: 12px;

      &::after {
        content: " ";
        width: 100%;
        height: 2px;
        bottom: 0;
        left: 0;
        background: $bh-blue--4;
        border-radius: 2px;
        position: absolute;
      }
    }
  }

  &__question {
    word-break: break-word;

    &-challenges {
      list-style: none;
      padding-left: 0 !important;
    }

    &-item {
      display: flex;
      align-items: center;
      justify-content: flex-start;
      padding: 4px 0;

      span {
        font-weight: 700;
        display: inline-block;
      }

      p {
        word-break: break-word;
        margin-left: 16px;
        margin-bottom: 0;
        font-size: 0.85715rem;
        font-weight: 700;
        line-height: 1.333333em;
      }
    }

    p:first-child {
      margin-bottom: 4px;
    }

    p:last-child {
      margin-bottom: 0;
    }
  }

  &__amount {
    margin-right: 8px;

    &--wrap {
      display: flex;
      align-items: center;
      justify-content: flex-start;
      min-height: 40px;
      padding: 10px 16px;
      width: 160px;
      min-width: 160px;
    }
  }

  .label {
    font-weight: 700;
    line-height: 1.715em;
    color: $bh-gray--2;
    margin-bottom: 3px;
    position: relative;

    &.label--underlined::after {
      content: " ";
      width: 100%;
      height: 2px;
      bottom: 0;
      left: 0;
      background: $bh-blue--4;
      border-radius: 2px;
      position: absolute;
    }
  }
}
</style>
